import {Component, HostListener, inject, OnInit, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SidebarComponent} from './layout/sidebar/sidebar.component';
import {NavigationEnd, Router, RouterOutlet} from "@angular/router";
import {TranslateService} from '@ngx-translate/core';
import {LoadingBarService, NgxLoadingBar} from "@ngx-loading-bar/core";
import {filter} from "rxjs";

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [
        CommonModule,
        SidebarComponent,
        RouterOutlet,
        NgxLoadingBar
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class App implements OnInit {
    sidebarCollapsed = signal(false);
    isLoginPage = signal(false);

    protected loadingBar = inject(LoadingBarService);
    private router = inject(Router);

    constructor(private translate: TranslateService) {
        // Configurar idiomas disponíveis
        this.translate.addLangs(['pt-BR', 'en']);

        // Definir idioma padrão
        this.translate.setFallbackLang('pt-BR');

        // Usar idioma do navegador ou padrão
        const browserLang = this.translate.getBrowserLang();
        const langToUse = browserLang && ['pt-BR', 'en'].includes(browserLang) ? browserLang : 'pt-BR';
        this.translate.use(langToUse);

        // Detectar mudanças de rota
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: any) => {
            this.isLoginPage.set(event.url === '/login' || event.url === '/');
        });
    }

    ngOnInit() {
        // Verificar se está na página de login
        this.isLoginPage.set(this.router.url === '/login' || this.router.url === '/');

        // Inicia com sidebar fechada em mobile
        this.checkScreenSize();
    }

    @HostListener('window:resize')
    onResize() {
        this.checkScreenSize();
    }

    checkScreenSize() {
        if (window.innerWidth <= 768) {
            this.sidebarCollapsed.set(true);
        } else {
            this.sidebarCollapsed.set(false);
        }
    }


    toggleSidebar() {
        this.sidebarCollapsed.set(!this.sidebarCollapsed());
    }

    closeSidebar() {
        this.sidebarCollapsed.set(true);
    }
}

